import { useState } from "react";
import { Loader } from "@rshbintech.dboul/core-ui";
import { useScrollLoading } from "@rshbintech.dboul/utils";

import { SIGNING_STATUSES_ANNOTATIONS } from "../signing-widget/constants";
import { SignedDocument } from "../types";
import { DocumentCard } from "../document-card";
import { DocumentsTotal } from "./documents-total";
import { DocumentsListProps } from "./types";
import { DOCUMENTS_COUNT_FOR_LOADING, LOADING_TIMEOUT } from "./constants";
import styles from "./styles.scss";

export const DocumentsList = ({
  taskId,
  documents,
  signingType,
  documentsInfo,
}: DocumentsListProps) => {
  const [lastDocumentCounter, setLastDocumentCounter] = useState(
    DOCUMENTS_COUNT_FOR_LOADING
  );

  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  const hasMoreData = lastDocumentCounter < documents.length;

  const onScrollToBottom = () => {
    setIsLoaderVisible(true);
    setTimeout(() => {
      setIsLoaderVisible(false);
      setLastDocumentCounter(
        (lastDocumentCounter) =>
          lastDocumentCounter + DOCUMENTS_COUNT_FOR_LOADING
      );
    }, LOADING_TIMEOUT);
  };

  const { setElement } = useScrollLoading({
    onDataLoad: onScrollToBottom,
    hasMoreData: hasMoreData,
  });

  const documentCards = (() =>
    documents
      .slice(0, lastDocumentCounter)
      .map((document: SignedDocument, index: number) => {
        const isLast =
          index === lastDocumentCounter - 1 || index === documents.length - 1;

        const errorText =
          document?.documentStatus?.errorText || document?.signatureInfo?.error
            ? SIGNING_STATUSES_ANNOTATIONS[signingType].DOCUMENT_ERROR
            : "";

        const signingStage = document?.signatureInfo?.signingStage || null;

        return (
          <DocumentCard
            key={document.id}
            isLast={isLast}
            document={document}
            taskId={taskId}
            errorText={errorText}
            signingStage={signingStage}
          />
        );
      }))();

  const bottomElement = isLoaderVisible ? (
    <Loader className={styles.loader} />
  ) : (
    <div ref={setElement} />
  );

  return (
    <>
      <div className={styles["documents-list"]}>
        {documentCards}
        {bottomElement}
      </div>
      {documents.length > 0 && (
        <DocumentsTotal
          documentsLength={documents.length}
          documentsInfo={documentsInfo}
        />
      )}
    </>
  );
};
